// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>20</span>&nbsp;&nbsp;What troubles and adversities you have shown me,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and yet you will turn and refresh me<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;and bring me from the deep of the earth again.<br> </p> </div></div>";
// Exports
module.exports = code;